import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {players} from "models/players-model"; // Importing players model for data handling
import {devConfig} from "config/config"; // Importing development configuration

export default class PlayersView extends JetView {
	/**
	 * Configures the layout of the PlayersView.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service for translations
		const theme = this.app.config.theme; // Theme configuration
		const screen = this.app.config.size; // Screen size configuration

		return {
			rows:[
			{
				view:"toolbar", css:theme, // Toolbar with specified theme
				elements:[
				{ view:"label", label:_("Jugadores"), localId:"label" }, // Label for "Players"
				{ width:4 }, // Spacer
				{
					view:"text", localId:"search", hidden:true, // Search input field, initially hidden
					autofill:true,
					on:{
						/**
						 * Event handler for timed key press in the search input.
						 * Clears the list and loads new data based on input value.
						 */
						onTimedKeyPress(){
							this.$scope.$$("list").clearAll(); // Clear the list
							const input = this.getValue().toLowerCase(); // Get the input value
							this.$scope.$$("list").load(devConfig.geturlApi()+"es/Client/GetClientById?id="+input); // Load data based on input
						}
					}
				},
				{
					view:"icon", icon:"mdi mdi-magnify", // Search icon
					state:"closed", localId:"search_icon", // Icon state management
					click:function(){
						// Toggle search input visibility
						if (this.config.state === "closed"){
							this.$scope.$$("label").hide(); // Hide label
							this.$scope.$$("search").show(); // Show search input
							this.$scope.$$("search").focus(); // Focus on search input
							this.config.state = "open"; // Update state
						}
						else if (this.config.state === "open"){
							this.$scope.$$("label").show(); // Show label
							this.$scope.$$("search").hide(); // Hide search input
							this.config.state = "closed"; // Update state
						}
					}
				},
				{
					type: "wide", relative: true, css: "close-bottom", // Close button configuration
					cols:[
					{
						view:"icon", icon:"wxi-close",  bottom: 20, right: 35, width: 30, height: 30, // Close icon
						click:() => this.show("/top/dashboard") // Navigate to dashboard on click
					}
					]
				}
				]
			},
			{
				view:"list", // List view for displaying players
				localId:"list", // Local ID for referencing the list
				css:"persons_list", // CSS class for styling
				autoheight:true, // Auto height adjustment
				select:true, // Enable selection
				tooltip:{
					template:_("Click twice to see more goodies") // Tooltip for list items
				},
				type:{
					/**
					 * Template for rendering list items.
					 * @param {Object} obj - The data object for the item.
					 * @returns {string} The HTML string for the item.
					 */
					template:obj =>
					`<div class="text">
					<span>${obj.id} ${obj.Login}</span> // Display player ID and Login
					<span class="money">$${obj.Balance}</span> // Display player balance
					</div>`,
					height:86, // Item height
				},
				on:{
					/**
					 * Event handler for after an item is selected.
					 * @param {string} id - The ID of the selected item.
					 */
					onAfterSelect:id => {
						this.app.callEvent("player:select",[id]); // Trigger player select event
					},
					/**
					 * Event handler for double-clicking an item.
					 * @param {string} id - The ID of the double-clicked item.
					 */
					onItemDblClick:id => {
						if (this.getUrl()[0].page !== "customers"){ // Check current page
							this.show("customers?user="+id+"/information"); // Navigate to customer information
						}else{
							window.location.href = "#!/top/customers?user="+id+"/information"; // Redirect to customer information
							window.location.reload(true) // Reload the page
						}
					}
				}
			}
			]
		};
	}

	/**
	 * Initializes the PlayersView.
	 */
	init(){
		const _ = this.app.getService("locale")._; // Localization service
		const list = this.$$("list"); // Reference to the list

		// Wait for player data to be ready
		players.waitData.then(() => {
			if (this.getUrl()[1].page !== "customers"){ // Check if not on customers page
				const cur_user = this.getParam("user",true); // Get current user ID
				list.select(cur_user); // Select current user in the list
				list.showItem(cur_user); // Show current user item
			}
		});

		// Event handler for saving customer data
		this.on(this.app,"customer:save",(data) => {
			const id = data.id || this.getParam("user",true); // Get ID from data or current user
			players.updateItem(id,data); // Update player data
			webix.message(_("Saved")); // Show saved message
		});

		// Event handler for updating form data
		this.on(this.app,"form:update",(id) => {
			players.waitData.then(() => {
				const user = list.getSelectedId(); // Get selected user ID
				if (!user){ // If no user is selected
					list.select(id || 1); // Select the provided ID or default to 1
					list.showItem(id || 1); // Show the selected item
				}
				else {
					this.app.callEvent("customer:updatedata",[list.getItem(user)]); // Trigger update event with selected user data
				}
			});
		});

		// Event handler for selecting a record
		this.on(this.app,"taction:select",record => {
			if (record) {
				const person = players.find(obj => obj.company === record.id)[0]; // Find person by company ID
				if (person){
					list.select(person.id); // Select found person
					list.showItem(person.id); // Show found person item
				}
			}
			else
				list.unselect(); // Unselect if no record is provided
		});

		// Event handler for when payment history is ready
		this.on(this.app,"payment:history:ready",() => players.waitData.then(() => list.select(1))); // Select the first item in the list
	}
}

// FILE DOCUMENTED
